export default __webpack_public_path__ + "images/vender-passagem-ico.svg";